import { apiGroupAppointments, apiLocations } from 'tsx/constants/api';
import { get } from 'tsx/libs/genericAction';
import { createThunks, Params } from 'tsx/libs/reduxUtils';

export const typePrefix = 'locations';

const config = [
  { actionType: 'getAll', apiPath: apiLocations, method: get, actionParams: { limit: 0 } },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiLocations}/${params.id}`, method: get },
  { actionType: 'getDistance', apiPath: `${apiLocations}/distance`, method: get },
  {
    actionType: 'getGroupMapData',
    apiPath: (params: Params) => `${apiGroupAppointments}/${params.id}/map`,
    method: get,
  },
];

export const { getAll, getOne, getDistance, getGroupMapData } = createThunks(typePrefix, config);
